import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Button } from '@mui/material'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { focusElemnt, getInt, getText, navigation3 } from '../../../common/helper'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { viewColumns, columnsHeader, baseStyle } from './constants'
import { calculateDynamicFormatPortrait } from '../../Reports/BookingReports/BookingConstants'
import useToken from '../../../helpers/useTokens'
import LineinputV2 from '../../../common/lineinputV2'
import { useAtom } from 'jotai'
import { alertAtom } from '../../../common/jotaiState/globalStateAtoms'
import { PostRequest, PostRequestV2 } from '../../../common/api'
import { urls } from '../../../common/constants'
import { showReportAtom } from './atoms'
const BranchwiseCollectionAndDispatchMemoCollectionTable = (props) => {
  const { sourceBranch, sourceCity } = props
  const { headerData, reportName, tableData, setTableData,roleName} = props
  const { loginData } = useToken()
  const { intCompanyID, intUserID, strCompanyName } = loginData
  const xpcolumns = viewColumns.filter((col) => col.field !== 'Action')
  const [, setAlert] = useAtom(alertAtom)
  const [, setShowReport] = useAtom(showReportAtom)
  const [generatePDF, setGeneratePDF] = useState(false)
  const [load, setLoad] = useState(false)
  const [showTable, setShowTable] = useState(true)
  const [filterData, setFilterData] = useState([])
  useEffect(() => {
  if (Array.isArray(tableData) && tableData.length > 0) {
    const totals = tableData.reduce(
      (acc, curr) => {
        acc.BusCollectionAmt += Number(curr.BusCollectionAmt) || 0;
        acc.CargoCollectionAmt += Number(curr.CargoCollectionAmt) || 0;
        acc.ClosingBalance += Number(curr.ClosingBalance) || 0;
        acc.OldReceivedAmt += Number(curr.OldReceivedAmt) || 0;
        acc.OldReceivedBankAmt += Number(curr.OldReceivedBankAmt) || 0;
        acc.OpeningBalance += Number(curr.OpeningBalance) || 0;
        acc.ReceivedAmt += Number(curr.ReceivedAmt) || 0;
        acc.ReceivedBankAmt += Number(curr.ReceivedBankAmt) || 0;
        acc.openingblnc += Number(curr.openingblnc) || 0;
        acc.TotalAmount += Number(curr.TotalAmount) || 0;
        return acc;
      },
      {
        BusCollectionAmt: 0,
        CargoCollectionAmt: 0,
        ClosingBalance: 0,
        OldReceivedAmt: 0,
        OldReceivedBankAmt: 0,
        OpeningBalance: 0,
        ReceivedAmt: 0,
        ReceivedBankAmt: 0,
        openingblnc: 0,
        TotalAmount: 0,
      }
    );

    // Format all totals to 2 decimal places
    const formattedTotals = Object.fromEntries(
      Object.entries(totals).map(([key, value]) => [key, value.toFixed(2)])
    );

    const updatedData = [
      ...tableData,
      { ...formattedTotals, isTotal: true, sn: "Total" }
    ];
    setFilterData(updatedData);
  } else {
    setFilterData([]);
  }
}, [tableData]);


  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
  const filteredViewColumns = viewColumns.filter(col => !(roleName !== 'MTPL Admin' && roleName !== 'Admin' && col.field === 'Action'));
  const printClick = (isSave) => {
    setLoad(true)
    setGeneratePDF(true)
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const widthCell = xpcolumns.reduce((acc, col) => acc + (parseInt(col.minWidth, 10) || 0), 0)
    const HeaderColumns = columnsHeader.map((col) => {
      return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = xpcolumns.map((col) => {
      return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({
      orientation: 'p',
      format: calculateDynamicFormatPortrait((widthCell > 850 ? widthCell : 850) + 60),
      unit: 'px',
      compress: true,
    })
    var pageSize = doc.internal.pageSize
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var scaleFactor = pageWidth / (pdfColumns.length > 12 ? 1122 : 850)
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()

    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(scaleFactor * 14)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(
        `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
        doc.internal.pageSize.width / 2 -
        (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) /
        2 +
        90,
        pageHeight - 5
      )
    }
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: headerData,
      columnStyles: Array.from({ length: HeaderColumns.length }, () => ({ ...baseStyle, fontSize: scaleFactor * 14 })),
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: scaleFactor * 14,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: scaleFactor * 12,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: filterData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      columnStyles: Array.from({ length: pdfColumns.length }, () => ({ ...baseStyle, fontSize: scaleFactor * 14 })),
      theme: 'grid',
      didParseCell: (data) => {
        if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
          data.cell.styles.halign = 'right'
        } else {
          data.cell.styles.halign = 'left'
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(scaleFactor * 40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(scaleFactor * 14).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text(`Cargo System |${reportName} Report`, 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(scaleFactor * 14).setFont('Roboto', 'bold')
        doc.text(`Company Name :${strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
    })
    doc.setProperties({
      title: `User With Trasaction Right Report.pdf`,
      subject: 'User With Trasaction Right Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${reportName} Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setGeneratePDF(false)
        setLoad(true)
        const pdfUrl = doc.output('bloburl')
        document.getElementById('LrCancelAndPenalityReportoutput').data = pdfUrl
        // document.getElementById('LrCancelAndPenalityReportoutput').data = doc.output('datauristring', 'DeliveryDetailedReport..pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setGeneratePDF(false)
        setLoad(true)
        const pdfUrl = doc.output('bloburl')
        document.getElementById('LrCancelAndPenalityReportoutput').data = pdfUrl
        // document.getElementById('LrCancelAndPenalityReportoutput').data = doc.output('datauristring', 'DeliveryDetailedReport..pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
  const handleTableSave = async (item) => {
    const { ID,BranchID, OldReceivedAmt, OldReceivedBankAmt, OldRemarks:rawRemarks } = item
    const OldRemarks = rawRemarks ?? '';
    const isBothZero = (+OldReceivedAmt || 0) === 0 && (+OldReceivedBankAmt || 0) === 0;
    if (!OldReceivedAmt) {
      setAlert({ show: true, msg: 'Please enter Received Cash Amount', nextId: '' })
    } else if (!OldReceivedBankAmt) {
      setAlert({ show: true, msg: 'Please enter Received Online Amount', nextId: '' })
    } 
    // else if (!isBothZero && OldRemarks.trim() === '') {
    //   setAlert({ show: true, msg: 'Please enter Remarks', nextId: '' })
    // } 
    else {
      const data = {
        CompanyID: intCompanyID,
        BranchID: BranchID,
        ID: ID || 0,
        ReceivedAmount: +OldReceivedAmt || 0,
        ReceivedBankAmount: +OldReceivedBankAmt || 0,
        Remarks: OldRemarks,
        ReceivedBy: intUserID,
      }
      const res = await PostRequest(urls.branchCollectionUpdate, data)
      if (res.status === 'Success') {
        setAlert({ show: true, success: true, msg: 'Branch collection updated successfully', nextId: '' })
        setShowReport(false)
        const smsdata = {
          intCompanyID: intCompanyID,
          intBranchID: BranchID,
          strType: 'FB',
          CashReceivedAmt: +OldReceivedAmt || 0,
          BankReceivedAmt: +OldReceivedBankAmt || 0,
          intUserID: intUserID,
        }
        const res = await PostRequestV2(urls.sendCargoSMSDirectBranchWise, smsdata)
        if (res.status === 'Success') {
          setShowReport(false)
        } else {
          setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
        }
      } else {
        setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
      }
    }
  }
  const handleTableCancel = (index) => {
    let newData = [...filterData]
    if (index >= 0 && index <= newData?.length) {
      newData[index].OldReceivedAmt = filterData[index].ReceivedAmt
      newData[index].OldReceivedBankAmt = filterData[index].ReceivedBankAmt
      newData[index].OldRemarks = filterData[index].Remarks
      setFilterData(newData)
    }
  }
  const handleInputChange = (e, index,key) => {
    let newVal = [...filterData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index][key] = e.target.value
      setFilterData(newVal)
    }
  }
  const getNumberWithMinusAndDecimal = (value) => {
    let newValue = value.trim();
    if (newValue.startsWith('-')) {
      newValue = '-' + newValue.slice(1).replace(/[^0-9.]/g, '');
    } else {
      newValue = newValue.replace(/[^0-9.]/g, '');
    }
    const parts = newValue.split('.');
    if (parts.length > 2) {
      newValue = parts[0] + '.' + parts.slice(1).join('').replace(/\./g, '');
    } else if (parts.length === 2) {
      newValue = parts[0] + '.' + parts[1].slice(0, 2);
    }
    return newValue;
  };
  const DispatchMemoRow = (props) => {
    const { item, index } = props
    return (
      <>
          {
            item.isTotal ?
              <>
                <TableCell
                  className="reportTD"
                  colSpan={3}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.sn}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.openingblnc}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.BusCollectionAmt}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.CargoCollectionAmt}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.TotalAmount}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.OldReceivedAmt}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.OldReceivedBankAmt}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={1}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {item.ClosingBalance}
                </TableCell>
                <TableCell
                  className="reportTD"
                  colSpan={3}
                  style={{ background: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}
                >
                  {/* {item.NetAmount} */}
                </TableCell>
              </> : 
                <TableRow key={index + 'ss0xc'}>
                  {filteredViewColumns?.map((i, index2) => (
                    <TableCell
                      key={index2 + 'ewdsi'}
                      className="reportTD"
                      colSpan={1}
                      style={{
                        background: 'F5FAFE',
                        whiteSpace: 'pre',
                        fontSize: '12px',
                        fontWeight: '500',
                        textAlign: i.pdfColSx.halign,
                        padding: (i.field === 'OldReceivedAmt' || i.field === 'OldReceivedBankAmt') ? '5px' : undefined,
                      }}
                    >
                      {item.IsReceivable === 1 && i.field === 'OldReceivedAmt' ? (
                        <div
                          className={'input--wrapper right'}
                          style={{ maxHeight:roleName !== 'MTPL Admin' && roleName !== 'Admin'?'40px':'25px', display: 'flex', alignItems: 'center', marginBottom: '0px' }}
                        >
                          <LineinputV2
                            filter={getNumberWithMinusAndDecimal}
                            value={item.OldReceivedAmt}
                            onBlur={(e) => {
                              handleInputChange(e, index, 'OldReceivedAmt')
                            }}
                            disabled={roleName !== 'MTPL Admin' && roleName !== 'Admin'}
                          />
                        </div>
                      ) : item.IsReceivable === 1 && i.field === 'OldReceivedBankAmt' ? (
                        <div
                          className={'input--wrapper right'}
                          style={{ maxHeight:roleName !== 'MTPL Admin' && roleName !== 'Admin'?'40px':'25px', display: 'flex', alignItems: 'center', marginBottom: '0px' }}
                        >
                          <LineinputV2
                            filter={getNumberWithMinusAndDecimal}
                            value={item.OldReceivedBankAmt}
                            onBlur={(e) => {
                              handleInputChange(e, index, 'OldReceivedBankAmt')
                            }}
                            disabled={roleName !== 'MTPL Admin' && roleName !== 'Admin'}
                          />
                        </div>
                      ) : item.IsReceivable === 1 && i.field === 'OldRemarks' ? (
                        <div
                          className={'input--wrapper'}
                          style={{maxHeight:roleName !== 'MTPL Admin' && roleName !== 'Admin'?'25px':'25px', alignItems: 'center' }}
                        >
                          <LineinputV2
                            filter={getText}
                            value={item.OldRemarks}
                            onBlur={(e) => {
                              handleInputChange(e, index, 'OldRemarks')
                            }}
                            disabled={roleName !== 'MTPL Admin' && roleName !== 'Admin'}
                          />
                        </div>
                      ) : i.field === 'Action' ?roleName !== 'MTPL Admin' && roleName !== 'Admin'?<></>: (
                        <Item className="userReport">
                          <Item className="userReport-buttons">
                            <>
                              <Box>
                                <Button
                                  variant="outlined"
                                  className="userWisereporttembtn"
                                  onClick={() => {
                                    handleTableCancel(index)
                                  }}
                                  style={{ fontSize: '14px', cursor: 'pointer' }}
                                  onKeyDown={(e) => navigation3(e, 'PrintBtn', 'ExpToExlbtn', () => { })}
                                  id="PdfBtn"
                                  disabled={!(item.IsReceivable === 1)}
                                >
                                  Reset
                                </Button>
                              </Box>
                              <Box>
                                <Button
                                  type="button" 
                                  variant="contained"
                                  className="btn btn-primary"
                                  style={{ height: '39px', fontSize: '14px', cursor: 'pointer' }}
                                  onClick={() => {
                                    handleTableSave(item)
                                  }}
                                  id="PrintBtn"
                                  disabled={!(item.IsReceivable === 1)}
                                  onKeyDown={(e) => navigation3(e, 'fromDate', 'PdfBtn', () => { })}
                                >
                                  Save
                                </Button>
                              </Box>
                            </>
                          </Item>
                        </Item>
                      ) : (
                        item[i.field]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
          }
      </>
    )
  }
  return (
    <>
      <Item className="userReport">
        <Item style={{ padding: '8px 0 0 8px' }} className="userReport-heading">
          Report For:{reportName} Report
        </Item>
        <Item className="userReport-buttons">
          {showTable ? (
            <>
              <Box id={'ExpToExlbtnBox'}>
                <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, 'PdfBtn', 'generateButton', () => { })}>
                  <ReactHtmlTableToExcel
                    id="ExpToExlbtn"
                    className="userWisereporttemExcelBtn"
                    table="table-to-xls"
                    filename={`${reportName} Report ${currentDateTime}`}
                    sheet="tablexls"
                    buttonText="Export to Excel"
                  />
                </Item>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => {
                    setShowTable(false)
                    printClick(true)
                  }}
                  onKeyDown={(e) => navigation3(e, 'PrintBtn', 'ExpToExlbtn', () => { })}
                  id="PdfBtn"
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => {
                    setShowTable(false)
                    printClick(false)
                  }}
                  id="PrintBtn"
                  onKeyDown={(e) => navigation3(e, 'fromDate', 'PdfBtn', () => { })}
                >
                  Print
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box>
                <Button
                  id="backBtn"
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => setShowTable(true)}
                  onKeyDown={(e) =>
                    navigation3(e, '', 'generateButton', () => {
                      setShowTable(true)
                      focusElemnt('generateButton')
                    })
                  }
                >
                  Back
                </Button>
              </Box>
            </>
          )}
        </Item>
      </Item>
      {showTable ? (
        <>
          <Stack sx={{ marginLeft: 2, marginRight: 2, maxHeight: 660, paddingTop: '10px', overflowY: 'hidden' }} >
            <TableContainer className="scrollBlue" style={{ border: '1px solid #aeaeae', borderRadius: '6px' }}>
              <Table className="table1 table-Report collection-table" size="small" aria-label="a dense table">
                <TableHead style={{ fontWeight: 'bold' }}>
                  <TableRow>
                    <TableCell
                      colSpan={filteredViewColumns.length}
                      style={{
                        color: '#444444',
                        backgroundColor: '#bfe1ff',
                        fontSize: '12px',
                        lineheight: '16px',
                        letterspacing: '0.24px',
                        fontWeight: '500',
                        whiteSpace: 'pre',
                        position: 'sticky',
                        top: 0,
                        zIndex: 2,
                      }}
                    >
                      {reportName} Report
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    {filteredViewColumns?.map((i, index) => (
                      <TableCell
                        key={index}
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#e5f3ff',
                          color: '#444',
                          fontSize: '12px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                          fontWeight: '500',
                          textAlign: `${i.pdfColSx.halign}`,
                          whiteSpace: 'pre',
                          position: 'sticky',
                          top: 30,
                          zIndex: 1,
                        }}
                        colSpan={1}
                      >
                        {i.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {filterData?.length ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {filterData?.map((item, index) => (
                      <DispatchMemoRow item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={12}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                )}
              </Table>
              <Table id="table-to-xls" style={{ display: 'none' }} className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '25px', fontWeight: '500', textAlign: 'left' }} colSpan={4}>
                      <h3 style={{ paddingLeft: '17px' }}>Report For:{reportName} Report</h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '25px', fontWeight: '500', textAlign: 'left' }} colSpan={5}>
                      <h3 style={{ paddingLeft: '17px' }}>Company Name : {strCompanyName}</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={9}></TableCell>
                  </TableRow>
                  <TableRow>
                    {columnsHeader?.map((i, index) => (
                      <TableCell
                        key={index}
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#444444',
                          fontSize: '20px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                          fontWeight: '500',
                          textAlign: 'left',
                        }}
                        colSpan={i.colSpan}
                      >
                        {i.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    <TableCell
                      className="ReportItemHead"
                      style={{ color: '#454646', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={3}
                    >
                      {strCompanyName}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{ color: '#454646', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={3}
                    >
                      {sourceCity?.CityName}
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{ color: '#454646', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={3}
                    >
                      {sourceBranch?.BranchName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={9}></TableCell>
                  </TableRow>
                </TableHead>
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  <TableRow>
                    {xpcolumns?.map((i, index) => (
                      <TableCell
                        key={index}
                        className="ReportItemHead"
                        style={{
                          backgroundColor: '#bfe1ff',
                          color: '#444444',
                          fontSize: '20px',
                          lineheight: '16px',
                          letterspacing: '0.24px',
                          fontWeight: '500',
                          textAlign: `${i.pdfColSx.halign}`,
                        }}
                        colSpan={1}
                      >
                        {i.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {filterData?.length < 1 ? (
                  <>
                    <TableBody>    
                      <TableRow>
                        <TableCell colSpan={12}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : (
                    <TableBody
                      className="filter-data-row"
                      style={{
                        textAlign: 'center',
                        fontSize: '12px',
                        lineheight: '16px',
                        letterspacing: '0.24px',
                        fontWeight: '500',
                        marginLeft: '5px',
                      }}
                    >
                      {filterData?.map((item, index) => (
                        <>
                          {
                            item.isTotal ?
                              <>
                                <TableCell
                                  className="reportTD"
                                  colSpan={3}
                                  style={{ background: '#EEEEEE', fontSize: '20px', fontWeight: '700', textAlign: 'right' }}
                                >
                                  {item.sn}
                                </TableCell>
                                <TableCell
                                  className="reportTD"
                                  colSpan={1}
                                  style={{ background: '#EEEEEE', fontSize: '20px', fontWeight: '700', textAlign: 'right' }}
                                >
                                  {item.openingblnc}
                                </TableCell>
                                <TableCell
                                  className="reportTD"
                                  colSpan={1}
                                  style={{ background: '#EEEEEE', fontSize: '20px', fontWeight: '700', textAlign: 'right' }}
                                >
                                  {item.BusCollectionAmt}
                                </TableCell>
                                <TableCell
                                  className="reportTD"
                                  colSpan={1}
                                  style={{ background: '#EEEEEE', fontSize: '20px', fontWeight: '700', textAlign: 'right' }}
                                >
                                  {item.CargoCollectionAmt}
                                </TableCell>
                                <TableCell
                                  className="reportTD"
                                  colSpan={1}
                                  style={{ background: '#EEEEEE', fontSize: '20px', fontWeight: '700', textAlign: 'right' }}
                                >
                                  {item.TotalAmount}
                                </TableCell>
                                <TableCell
                                  className="reportTD"
                                  colSpan={1}
                                  style={{ background: '#EEEEEE', fontSize: '20px', fontWeight: '700', textAlign: 'right' }}
                                >
                                  {item.OldReceivedAmt}
                                </TableCell>
                                <TableCell
                                  className="reportTD"
                                  colSpan={1}
                                  style={{ background: '#EEEEEE', fontSize: '20px', fontWeight: '700', textAlign: 'right' }}
                                >
                                  {item.OldReceivedBankAmt}
                                </TableCell>
                                <TableCell
                                  className="reportTD"
                                  colSpan={1}
                                  style={{ background: '#EEEEEE', fontSize: '20px', fontWeight: '700', textAlign: 'right' }}
                                >
                                  {item.ClosingBalance}
                                </TableCell>
                                <TableCell
                                  className="reportTD"
                                  colSpan={2}
                                  style={{ background: '#EEEEEE', fontSize: '20px', fontWeight: '700', textAlign: 'right' }}
                                >
                                  {/* {item.NetAmount} */}
                                </TableCell>
                              </> :
                              <TableRow key={index + 'swcw'}>
                                {xpcolumns?.map((i, index) => (
                                  <TableCell
                                    key={index + 'sw24cw'}
                                    className="reportTD"
                                    colSpan={1}
                                    style={{
                                      background: 'F5FAFE',
                                      whiteSpace: 'pre',
                                      fontSize: '20px',
                                      fontWeight: '500',
                                      textAlign: i.pdfColSx.halign,
                                    }}
                                  >
                                    {item[i.field]}
                                  </TableCell>
                                ))}
                              </TableRow>
                          }
                        </>
                      ))}
                    </TableBody>
                )}
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="LrCancelAndPenalityReportoutput"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
      {/* {showInput && (
        <Item className="userReport">
          <Item style={{ padding: '8px 0 0 8px' }} className="userReport-heading"></Item>
          <Item className="userReport-buttons">
            <>
              <Box>
                <Button
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => {
                    handleTableCancel()
                  }}
                  onKeyDown={(e) => navigation3(e, 'PrintBtn', 'ExpToExlbtn', () => {})}
                  id="PdfBtn"
                >
                  Reset
                </Button>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  className="btn btn-primary"
                  style={{ lineHeight: 1 }}
                  onClick={() => {
                    handleTableSave()
                  }}
                  id="PrintBtn"
                  onKeyDown={(e) => navigation3(e, 'fromDate', 'PdfBtn', () => {})}
                >
                  Save
                </Button>
              </Box>
            </>
          </Item>
        </Item>
      )} */}
    </>
  )
}

export default BranchwiseCollectionAndDispatchMemoCollectionTable
